export const buildTradesUrl = (params = {}) => {
  const { bet_value, top_trades_24h, top_pnl_24h, user_address, market_slug, category } = params;
  
  const searchParams = new URLSearchParams();
  if (bet_value)      searchParams.append('bet_value', bet_value);
  if (top_trades_24h) searchParams.append('top_trades_24h', 'True');
  if (top_pnl_24h)    searchParams.append('top_pnl_24h', 'True');
  if (user_address)   searchParams.append('user', user_address);
  if (market_slug)    searchParams.append('market', market_slug);
  if (category)       searchParams.append('category', category);

  const queryString = searchParams.toString();
  return `/polymarket${queryString ? '?' + queryString : ''}`;
};